import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

const TabNavigation = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const tabs = [
        {
            value: "check-user",
            label: "Check user using social media",
            path: "/test-promt/check-user-using-social-media",
        },
    ];

    const currentTab = tabs.find((tab) => location.pathname.includes(tab.value))?.value || "check-user";

    const handleTabChange = (value: string) => {
        const tab = tabs.find((tab) => tab.value === value);
        if (tab) {
            navigate(tab.path);
        }
    };

    useEffect(() => {
        if (location.pathname === "/test-promt") {
            navigate("/test-promt/check-user-using-social-media");
        }
    }, [location.pathname, navigate]);

    return (
        <Tabs value={currentTab} onValueChange={handleTabChange} className="w-full">
            <TabsList>
                {tabs.map((tab) => (
                    <TabsTrigger key={tab.value} value={tab.value}>
                        {tab.label}
                    </TabsTrigger>
                ))}
            </TabsList>
        </Tabs>
    );
};

export default TabNavigation; 